<mat-icon svgIcon="volume-up"></mat-icon>